<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Registration List"
    seFeDataSubtitle="A registration list component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component for displaying a list of registrations</p>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <div class="registration-list-docs-form">
              <form
                [formGroup]="form">
                <div>
                  <se-fe-form-field [seFeDataConfig]="{ label: 'Persona ID from your household' }">
                    <se-fe-form-field-text
                      formControlName="personaId"
                      seFeDataPlaceholder="Persona ID">
                    </se-fe-form-field-text>
                  </se-fe-form-field>
                </div>
                <se-fe-button seFeDataEmphasis="high" [seFeDataFullWidth]="true" seFeDataType="submit" (click)="updatePersonaId()">Submit</se-fe-button>
              </form>
          </div>
          <se-po-registration-list-example [personaId]="personaId"></se-po-registration-list-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
